export const blockSelector = {
    blockSelectorConditionTypesView: "block-selector-condition-types.view",
    blockSelectorSourceView: "block-selector-source.view",
    blockSelectorTypeView: "block-selector-type.view"
};
